import script from "./InvoiceInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceInfoCard.vue?vue&type=style&index=0&id=51c533e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c533e8"]])

export default __exports__